import { Schedule, SupervisedUserCircle } from "@mui/icons-material";
import { Box, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useUser } from "../../api/useAuth";
import { Avatar } from "../../components/fieldsViews/fields/Avatar";
import { FileField } from "../../components/fieldsViews/fields/FileField";
import { useField } from "../../api/useField";

export const UserDetail = () => {
    const { data: user } = useUser();
    const { formatedField: avatarField } = useField("directus_users", "avatar");
    const hasAvatar = !!user?.avatar
    
    if (!avatarField) return null;
    return (
		<Box>
			<Paper sx={{ mb: 2, p: 4, minHeight: 100, display: "flex", flexDirection: "column", gap: 2 }} elevation={1}>
				<Typography variant="h4" color="primary">
					Colaborador
				</Typography>

				<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
					<Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
						<Avatar value={user?.avatar?.id} />
						<Typography variant="h6">
							{user?.first_name} {user?.last_name}
						</Typography>
					</Box>
					<Box
						sx={{
							maxWidth: "350px",
							overflow: "hidden",
							textOverflow: "ellipsis",
							direction: "rtl",
							alignSelf: "flex-start",
						}}
					>
						<FileField
							value={hasAvatar? [{ id: user?.avatar?.id, directus_files_id: user?.avatar?.id }] : []}
							field={avatarField}
							fieldView="group"
							entity="directus_users"
							id={user?.id}
							extraOptions={{
								fileFolder: "5a432f8d-9409-4e83-8076-faff7fb40892",
								field: "avatar",
								hidden: {
									create: hasAvatar,
									update: true,
								},
							}}
						/>
					</Box>
				</Box>
			</Paper>
			<Paper sx={{ mb: 2, p: 4, minHeight: 100, display: "flex", flexDirection: "column", gap: 2 }} elevation={1}>
				<Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
					<Schedule color="primary" />
					<Typography
						variant="h6"
						color="primary"
						component={Link}
						to={`/staff-work-logs/${user?.id}`}
						sx={{ textDecoration: "none" }}
					>
						Registos de horas
					</Typography>
				</Box>
				<Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
					<SupervisedUserCircle color="primary" />
					<Typography
						variant="h6"
						color="primary"
						component={Link}
						to={`/staff_subjective_evaluation`}
						sx={{ textDecoration: "none" }}
					>
						Avaliações de desempenho
					</Typography>
				</Box>
			</Paper>
		</Box>
	);
};
